// One screen of the crew app: what it shows scrolls, what it does sits at the bottom,
// right above the tabs - the lower third of the tablet, where one hand in a glove
// reaches without letting go of the holder (TZ 15.3).

import { Button, Flex, theme } from 'antd';
import type { ButtonProps } from 'antd';
import type { ReactNode } from 'react';

import { MAIN_BUTTON } from './crewTheme';

interface Props {
  children: ReactNode;
  /** The buttons: the main one last, full width, under the secondary ones. */
  actions?: ReactNode;
}

export function CrewScreen({ children, actions }: Props) {
  const { token } = theme.useToken();
  return (
    <Flex vertical style={{ height: '100%', minHeight: 0 }}>
      <div style={{ flex: 1, overflow: 'auto', padding: 16 }}>{children}</div>
      {actions && (
        <Flex
          vertical
          gap={10}
          style={{ padding: '12px 16px', borderTop: `1px solid ${token.colorBorderSecondary}` }}
        >
          {actions}
        </Flex>
      )}
    </Flex>
  );
}

/** The one main button of a screen (TZ 15.3): full width, 64 px, saying what comes next. */
export function MainButton(props: Omit<ButtonProps, 'type' | 'block' | 'size'>) {
  return (
    <Button
      {...props}
      type="primary"
      block
      size="large"
      style={{ minHeight: MAIN_BUTTON, fontSize: 22, fontWeight: 700, ...props.style }}
    />
  );
}

/** A card of a crew screen, as in the approved prototype. */
export function CrewCard({ children, center = false }: { children: ReactNode; center?: boolean }) {
  const { token } = theme.useToken();
  return (
    <div
      style={{
        background: token.colorFillQuaternary,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: 14,
        padding: center ? '40px 16px' : 16,
        marginBottom: 14,
        textAlign: center ? 'center' : undefined,
      }}
    >
      {children}
    </div>
  );
}
